import React from 'react'
import { css, keyframes } from 'emotion'
import { View } from 'oio-react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import InitiativeView from 'src/apps/Initiative/apps/View'
import EventHome from '~/apps/Home'

const animateAppIn = keyframes`
   0% { opacity: 0; transform: translate3d(0, 5%, 0); }
   100% { opacity: 1; transform: translate3d(0, 0, 0); }
`

const animateViewIn = keyframes`
   0% { opacity: 0; transform: scale(0.8); }
   100% { opacity: 1; transform: scale(1); }
`

const EventsApp = () => {
   const match = useRouteMatch()

   return (
      <View
         position="relative"
         className={css`
            opacity: 1;
            animation: ${animateAppIn} 700ms ease both;
         `}
         minHeight="100vh"
         width="100%">
         <EventHome />
         <Switch>
            <Route
               path={`${match.path}/:initiativeSlug`}
               render={() => (
                  <View
                     className={css`
                        animation: ${animateViewIn} 700ms ease both;
                     `}
                     position="absolute"
                     top="0px"
                     left="0px"
                     width="100%"
                     height="100vh">
                     <InitiativeView />
                  </View>
               )}
            />
         </Switch>
      </View>
   )
}

export default EventsApp
